import { useQuery } from 'react-query';
import { Options } from '@frontend/fetch';
import { LimitedSchemaQueryOptions } from '@frontend/react-query-helpers';
import { SchemaFaxSummaryV1Service } from '../service';
import { GenerateSummaryIO } from '../types';

export const getGenerateSummaryQueryKey = (req: GenerateSummaryIO['input']) =>
  ['FaxSummaryV1', 'GenerateSummary', req] as const;
type QueryKey = ReturnType<typeof getGenerateSummaryQueryKey>;

/**
 * A hook that returns a query for the `GenerateSummary` endpoint.
 * @param req The request object to pass to the query.
 * @param options (optional) The options to pass to `useQuery`.
 * @param httpOptions (optional) The http options to pass to the schema function.
 */
export const useGenerateSummaryQuery = <E = unknown, D = GenerateSummaryIO['output']>(
  req: GenerateSummaryIO['input'],
  options?: LimitedSchemaQueryOptions<GenerateSummaryIO, E, D, QueryKey>,
  httpOptions?: Options
) =>
  useQuery<GenerateSummaryIO['output'], E, D, QueryKey>({
    queryKey: getGenerateSummaryQueryKey(req),
    queryFn: () => SchemaFaxSummaryV1Service.GenerateSummary(req, httpOptions),
    ...options,
  });
